import {Button, Paper} from "@mantine/core";
import {useSetHallPartsZonesMutation, useSetZonesMutation} from "../../../../api/zone";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {toggleLoading} from "../prices.slice";
import {useParams} from "react-router-dom";
import {notification} from "../../../../utils/notification";
import {useTranslation} from "react-i18next";
import {isErrorWithMessage, showErrorMessages} from "../../../../app/api";

const Actions = () => {
    const {t} = useTranslation();
    const params = useParams();
    const dispatch = useAppDispatch();
    const updatedSeats = useAppSelector(state => state.schema.updatedSeats);
    const hall_parts = useAppSelector(state => state.schema.data.hall_parts);
    const [setZonesApi] = useSetZonesMutation();
    const [setHallPartZonesApi] = useSetHallPartsZonesMutation()

    async function setSeatZonesPrices() {
        try {
            await setZonesApi({
                event: Number(params.id),
                seats: updatedSeats
            }).unwrap();
        } catch (e) {
            console.log('set seat prices error', e);
            if (isErrorWithMessage(e)) {
                showErrorMessages(e.data)
            }
        }
    }

    async function setHallPartZones() {
        try {
            if (hall_parts && hall_parts.length) {
                for (let hall_part of hall_parts) {
                    if (hall_part.zone) {
                        try {
                            await setHallPartZonesApi({
                                event: Number(params.id),
                                zone: hall_part.zone,
                                hall_part: hall_part.id
                            })
                        } catch (e) {
                            console.log(`set hall part zone error + ${hall_part.name}`, e)
                        }
                    }
                }
            }

        } catch (e) {
            console.log('set fan-zones prices error', e);
            if (isErrorWithMessage(e)) {
                showErrorMessages(e.data)
            }
        }
    }

    async function setZones() {
        try {
            if (params.id) {
                dispatch(toggleLoading());
                await setSeatZonesPrices();
                await setHallPartZones()
                notification({type: "success", title: t(`priceEditor.notifications.pricesSet`)});
                dispatch(toggleLoading());
            }

        } catch (e) {
            dispatch(toggleLoading());
            if (isErrorWithMessage(e)) {
                showErrorMessages(e.data)
            }
            console.log(e);
        }
    }

    return (
        <Paper mt={10} px={10}>
            <Button w={"100%"} onClick={setZones} mt={10}>
                {t(`priceEditor.setPrices`)}
            </Button>
        </Paper>
    );
};

export default Actions;
